'use strict';

wbApp.factory('contractTemplateSvc', ['$resource', '$q', 'repositorySvc', 
    function ($resource, $q, repositorySvc) {

        const ContractTemplate = $resource('/restapi/contract-templates/:id', {}, {
            'getById': {method: 'GET', url: '/restapi/contract-templates/:id'},
            'getAll': {method: 'GET', isArray: true, url: '/restapi/contract-templates'},
            'insert': {method: 'POST', url: '/restapi/contract-templates'},
            'update': {method: 'PUT', url: '/restapi/contract-templates/:id'},
            'delete': {method: 'DELETE', url: '/restapi/contract-templates/:id'},
            'getVariablesByType': {method: 'GET', isArray: true, url: '/restapi/contract-templates/template-types/:id/variables'},
            'getSampleByType': {method: 'GET', url: '/restapi/contract-templates/template-types/:id/sample-template'},
        });

        let contractTemplates;

        function createNew()
        {
            return {
                id: null,
                name: "",
                contractTemplateType: 0,
                templateData: ""
            };
        }

        function insert(model) {
            return repositorySvc.customPost(
                'insert',
                ContractTemplate,
                model);
        }

        function remove(id) {
            contractTemplates = null;
            return repositorySvc.customDelete(
                'delete',
                ContractTemplate,
                { id: id });
        }

        function update(model) {
            contractTemplates = null;
            return repositorySvc.customPutWithParams(
                'update',
                ContractTemplate,
                { id: model.id },
                convertDatesToDateString(model));
        }

        function getById(id) {
            return repositorySvc.customGet('getById', ContractTemplate, { id: id });
        }

        function getSampleByType(typeId) {
            return repositorySvc.customGet('getSampleByType', ContractTemplate, { id: typeId });
        }        

        function getAll(refresh) {
            if (!contractTemplates || refresh) {
                contractTemplates = repositorySvc.customGet('getAll', ContractTemplate, {});
            }
            return contractTemplates;
        }
        
        function getAllWithFilter(refresh, contractTemplateType) {
            if (typeof contractTemplateType === 'undefined' || contractTemplateType === null)
            {
                return getAll(refresh);
            }
            else
            {
                var deferred = $q.defer();
                var m = [];
                m.$promise = deferred.promise;

                let models = getAll(refresh);
                models.$promise.then(function() {
                    m.push.apply(m, _.filter(models, {'contractTemplateType': contractTemplateType}));
                    deferred.resolve(m);
                });
                
                return m;
            }
        }

        function getVariablesByType(typeId) {
            return repositorySvc.customGet('getVariablesByType', ContractTemplate, { id: typeId });
        }        
        
        return {
            createNew: createNew,
            getById: getById,
            getAll: getAll,
            insert: insert,
            remove: remove,
            update: update,
            getVariablesByType: getVariablesByType,
            getAllWithFilter: getAllWithFilter,
            getSampleByType: getSampleByType
        }
    }]);